<template>
  <section class="pb-4 m-4">
    <b-row class="match-height">
      <b-col
        xl="12"
        md="12"
        sm="12"
      >
        <transacciones :frompublic="true" />
      </b-col>
    </b-row>
    <hr>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import Transacciones from './TransList.vue'

export default {
  components: {
    BRow,
    BCol,
    Transacciones,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
